import { render, staticRenderFns } from "./a-keyboard-key.vue?vue&type=template&id=27c0a519&"
import script from "./a-keyboard-key.vue?vue&type=script&lang=js&"
export * from "./a-keyboard-key.vue?vue&type=script&lang=js&"
import style0 from "./a-keyboard-key.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports